export const STROKE_COLOR = '#28AAEB';
export const HIGHLIGHT_COLOR = '#ff00ff';

export const ROI_CONFIG = {
  padding: 20,
  clickablePadding: 4,

  line: {
    stroke: STROKE_COLOR,
    strokeWidth: 3,
    hitStrokeWidth: 10,
    fill: `${STROKE_COLOR}33`,
  },

  anchor: {
    radius: 8,
    stroke: STROKE_COLOR,
    strokeWidth: 2.5,
    fill: `${STROKE_COLOR}33`,
  },

  directionIndicator: {
    offsetX: 9,
    scaleX: 2.5,
    scaleY: 2,
    sides: 3,
    strokeWidth: 1,
  },

  labelBg: {
    cornerRadius: 3,
    fill: 'black',
  },

  labelText: {
    fill: 'white',
    fontSize: 16,
  },
};
